jQuery(document).ready(function () {
  if ($('.simpleheaderbis').length > 0) {
    $(".simpleheaderbis_haschild").hover(function () {
      $(this).next(".simpleheaderbis_childrenbox").toggle();
    });
    $(".simpleheaderbis_childrenbox").hover(function () {
      $(this).toggle();
    });
    $(".simpleheaderbis_mobiletrigger").click(function () {
      $(".simpleheaderbis_mobilebar").toggleClass("simpleheaderbis_mobilebar-active");
      $(".simpleheaderbis_mobilemenu").slideToggle();
    });
    $(".simpleheaderbis_mobilehaschild").click(function () {
      $(this).next(".simpleheaderbis_mobilechildren").slideToggle();
      $(this).prev(".simpleheaderbis_arrow").toggleClass("simpleheaderbis_arrow-active");
    });
    $('.simpleheaderbis_button').on('click', function () {
      $('.recall').fadeIn();
    });
    $('.recall').on('click', function (e) {
      var $recall = $('.recall_container');

      if (!$recall.is(e.target) && $recall.has(e.target).length === 0) {
        $('.recall').fadeOut();
      }
    });
  }

  if ($('.bannerslider').length > 0) {
    if ($(window).width() > 1023) {
      $(document).scroll(function () {
        if ($(document).scrollTop() >= 1) {
          $('.simpleheaderbis_logo').attr('src', '/wp-content/themes/index/dist/img/doublev-dark.svg');
          $('.simpleheaderbis').css('background-color', 'white');
          $('.simpleheaderbis_link').css('color', '#313233');
          $('.simpleheaderbis_call a').css('color', '#313233');
          $('.simpleheaderbis_svg').css('filter', 'brightness(0) saturate(100%) invert(14%) sepia(8%) saturate(215%) hue-rotate(169deg) brightness(90%) contrast(82%)');
          $(".simpleheaderbis_link").hover(function () {
            $(this).css('color', '#8a1827');
          }, function () {
            $(this).css('color', '#313233');
          });
        } else {
          $('.simpleheaderbis_logo').attr('src', '/wp-content/themes/index/dist/img/doublev-white.svg');
          $('.simpleheaderbis').css('background-color', 'transparent');
          $('.simpleheaderbis_link').css('color', 'white');
          $('.simpleheaderbis_call a').css('color', 'white');
          $('.simpleheaderbis_svg').css('filter', 'brightness(0) saturate(100%) invert(95%) sepia(5%) saturate(0%) hue-rotate(336deg) brightness(105%) contrast(105%)');
          $(".simpleheaderbis_link").hover(function () {
            $(this).css('color', '#8a1827');
          }, function () {
            $(this).css('color', '#ffffff');
          });
        }
      });
      $('.content').css('padding-top', '0');
      $('.simpleheaderbis_logo').attr('src', '/wp-content/themes/index/dist/img/doublev-white.svg');
      $('.simpleheaderbis').css('background-color', 'transparent');
      $('.simpleheaderbis_link').css('color', 'white');
      $('.simpleheaderbis_call a').css('color', 'white');
      $('.simpleheaderbis_svg').css('filter', 'brightness(0) saturate(100%) invert(95%) sepia(5%) saturate(0%) hue-rotate(336deg) brightness(105%) contrast(105%)');
      $(".simpleheaderbis_link").hover(function () {
        $(this).css('color', '#8a1827');
      }, function () {
        $(this).css('color', '#ffffff');
      });
    }
  }
});